import { useEffect } from 'react';
import { useMatches } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const APP_NAME = 'Fitta';

export const useDocumentTitle = () => {
  const matches = useMatches();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const match = [...matches].reverse().find(m => m.handle?.titleKey);
    document.title = match ? `${t(match.handle.titleKey)} | ${APP_NAME}` : APP_NAME;
  }, [matches, t, i18n.language]);
};

export default useDocumentTitle;
